import Reac, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { SERVIDOR } from '../../config';

const AdminUsersPanel = () => {
  const navigate = useNavigate();

  const handleViewUsers = () => {
    navigate('/userTable');
  };

  const handleAddUser = () => {
    navigate("/UserRegistration");
  };



  const handleNavigateToLogin = () => {
    navigate('/products');
  };

  const handleAddProduct = () => {
    navigate("/ProductRegistration");
  };

  useEffect(() => {
    validarAdmin()

  }, [])

  const validarAdmin = async () => {
    try {
      const token = localStorage.getItem('adminToken')

      const response = await axios.post(SERVIDOR + '/api/validar-admin', { adminToken: token })

      const data = response.data;

      if (data.ok) {
        // alert(`Sesión iniciada como ${data.accessToken}`);

      } else {
        alert('Acceso denegado');
        // navigate('/loginAdmin') 
      }
    } catch (error) {

    }



  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 pt-16">
      <div className="max-w-6xl mx-auto p-8">
        {/* Header con botón de login */}
        <div className="mb-12 flex justify-between items-center">
          <div>
            <h2 className="text-4xl font-bold text-[#697565] mb-2">
              Panel de Administración
            </h2>
            <p className="text-gray-600">
              Gestiona los usuarios y productos del sistema de manera eficiente
            </p>
          </div>
          <button
            onClick={handleNavigateToLogin}
            className="bg-[#697565] text-white px-7 py-4 rounded-lg hover:bg-[#798575] shadow-md transition-all duration-300 font-semibold text-sm"
          >
            Ir a Productos →
          </button>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Ver Usuarios Card */}
          <button
            onClick={handleViewUsers}
            className="group w-full h-full flex flex-col items-center justify-center p-8 rounded-xl bg-white hover:bg-[#697565] border-2 border-gray-100 hover:border-[#697565] shadow-lg hover:shadow-xl transition-all duration-300 min-h-[16rem] hover:-translate-y-1"
          >
            <span className="text-3xl mb-4 text-[#697565] group-hover:text-white">👥</span>
            <h3 className="text-xl font-semibold text-gray-800 group-hover:text-white mb-2">
              Ver Usuarios
            </h3>
            <p className="text-sm text-gray-500 group-hover:text-gray-100 text-center">
              Consulta la lista completa de usuarios
            </p>
            <span className="mt-4 text-gray-400 group-hover:text-white">→</span>
          </button>

          {/* Agregar Usuario Card */}
          <button
            onClick={handleAddUser}
            className="group w-full h-full flex flex-col items-center justify-center p-8 rounded-xl bg-white hover:bg-[#697565] border-2 border-gray-100 hover:border-[#697565] shadow-lg hover:shadow-xl transition-all duration-300 min-h-[16rem] hover:-translate-y-1"
          >
            <span className="text-3xl mb-4 text-[#697565] group-hover:text-white">➕</span>
            <h3 className="text-xl font-semibold text-gray-800 group-hover:text-white mb-2">
              Agregar Usuario
            </h3>
            <p className="text-sm text-gray-500 group-hover:text-gray-100 text-center">
              Registra nuevos usuarios en el sistema
            </p>
            <span className="mt-4 text-gray-400 group-hover:text-white">→</span>
          </button>

          {/* Gestionar Usuarios Card */}
          {/* <button 
            onClick={handleManageUsers}
            className="group w-full h-full flex flex-col items-center justify-center p-8 rounded-xl bg-white hover:bg-[#697565] border-2 border-gray-100 hover:border-[#697565] shadow-lg hover:shadow-xl transition-all duration-300 min-h-[16rem] hover:-translate-y-1"
          >
            <span className="text-3xl mb-4 text-[#697565] group-hover:text-white">⚙️</span>
            <h3 className="text-xl font-semibold text-gray-800 group-hover:text-white mb-2">
              Gestionar Usuarios
            </h3>
            <p className="text-sm text-gray-500 group-hover:text-gray-100 text-center">
              Modifica o elimina usuarios existentes
            </p>
            <span className="mt-4 text-gray-400 group-hover:text-white">→</span>
          </button> */}

          {/* Agregar Producto Card */}
          <button
            onClick={handleAddProduct}
            className="group w-full h-full flex flex-col items-center justify-center p-8 rounded-xl bg-white hover:bg-[#697565] border-2 border-gray-100 hover:border-[#697565] shadow-lg hover:shadow-xl transition-all duration-300 min-h-[16rem] hover:-translate-y-1"
          >
            <span className="text-3xl mb-4 text-[#697565] group-hover:text-white">🛍️</span>
            <h3 className="text-xl font-semibold text-gray-800 group-hover:text-white mb-2">
              Agregar Producto
            </h3>
            <p className="text-sm text-gray-500 group-hover:text-gray-100 text-center">
              Registra nuevos productos en el sistema
            </p>
            <span className="mt-4 text-gray-400 group-hover:text-white">→</span>
          </button>
        </div>

        {/* Footer Info */}
        <div className="mt-12 p-6 bg-white rounded-xl shadow-md border border-gray-100">
          <div className="flex items-start space-x-4">
            <div className="p-3 rounded-full bg-[#697565]/10">
              <span className="text-xl">👥</span>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-gray-800 mb-1">
                Centro de Administración
              </h4>
              <p className="text-gray-600 text-sm">
                Desde este panel podrás realizar todas las operaciones relacionadas con la gestión de usuarios y productos.
                Asegúrate de tener los permisos necesarios para cada operación.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminUsersPanel;